// extracted by mini-css-extract-plugin
export var container = "_aw-0";
export var icon = "_aw-1";
export var text = "_aw-2";